import React from "react"

type FilterJoin = "or" | "and"

interface JoinToggleProps {
  value: FilterJoin
  onChange: (next: FilterJoin) => void
}

export const JoinToggle: React.FC<JoinToggleProps> = ({ value, onChange }) => {
  const modes: { key: FilterJoin; label: string }[] = [
    { key: "or", label: "OR" },
    { key: "and", label: "AND" },
  ]
  return (
    <div className="flex h-6 rounded-md bg-surface-1 p-0.5 text-xs">
      {modes.map((mode) => {
        const selected = value === mode.key
        return (
          <button
            key={mode.key}
            type="button"
            aria-label={`Join with ${mode.label}`}
            onClick={(event) => {
              event.preventDefault()
              event.stopPropagation()
              onChange(mode.key)
            }}
            className={`px-2 rounded font-medium transition-colors cursor-pointer ${
              selected
                ? "bg-white dark:bg-content4 text-foreground shadow-sm"
                : "text-coval-text-muted hover:text-coval-text"
            }`}
          >
            {mode.label}
          </button>
        )
      })}
    </div>
  )
}
